import {
  Envelope,
  FacebookLogo,
  Gift,
  InstagramLogo,
  LinkedinLogo,
  MapPin,
  Phone,
  SpotifyLogo,
  TiktokLogo,
  YoutubeLogo,
} from '@phosphor-icons/react';
import type { Icon } from '@phosphor-icons/react';

import { WIDGETS_ASSET_HOST } from '@/shared/config/assets';

export interface FooterLink {
  badge?: string;
  href: string;
  label: string;
  target?: '_blank' | '_self';
}

export interface FooterSection {
  links: FooterLink[];
  title: string;
}

export interface FooterCountryLink {
  flagSrc: string;
  href: string;
  label: string;
}

export type FooterIconName =
  | 'envelope'
  | 'facebook'
  | 'gift'
  | 'instagram'
  | 'linkedin'
  | 'map-pin'
  | 'phone'
  | 'spotify'
  | 'tiktok'
  | 'youtube';

export interface FooterContactGroup {
  Icon?: Icon;
  icon?: FooterIconName;
  items: { href: string; label: string }[];
  title: string;
}

export interface FooterSocialLink {
  Icon?: Icon;
  icon?: FooterIconName;
  href: string;
  label: string;
}

export interface FooterContent {
  contactGroups?: FooterContactGroup[];
  copyrightText?: string;
  countryLinks?: FooterCountryLink[];
  description?: string;
  extraLinks?: FooterLink[];
  legalText?: string;
  programSections?: FooterSection[];
  resourceSections?: FooterSection[];
  socialLinks?: FooterSocialLink[];
}

export const FOOTER_ICON_MAP: Record<FooterIconName, Icon> = {
  envelope: Envelope,
  facebook: FacebookLogo,
  gift: Gift,
  instagram: InstagramLogo,
  linkedin: LinkedinLogo,
  'map-pin': MapPin,
  phone: Phone,
  spotify: SpotifyLogo,
  tiktok: TiktokLogo,
  youtube: YoutubeLogo,
};

export const GIFT_CARD_ICON = Gift;
export const DEFAULT_GIFTCARD_URL = 'https://adipa.cl/regala-una-giftcard-adipa/';
export const DEFAULT_HOME_URL = 'https://adipa.cl';
export const DEFAULT_LOGO_SRC = `${WIDGETS_ASSET_HOST}/images/logo-adipa-white.svg`;
